import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Head from 'next/head';
import { CONFIG } from '@/constants/config';
import { hostnameWithoutLang } from '@/utils/helpers';

export const BusinessPageSeo: React.FC = () => {
  const { t, i18n } = useTranslation();

  const baseUrl = useMemo(() => {
    return `${CONFIG.protocol}://${hostnameWithoutLang(CONFIG.host)}`;
  }, []);

  const title = t('business.seo.title');
  const description = t('business.seo.description');

  const jsonLd = useMemo(
    () => ({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${baseUrl}/#organization`,
          name: 'Tap.az',
          url: `${baseUrl}/`,
          logo: {
            '@type': 'ImageObject',
            url: `https://${CONFIG.assetHost}/assets/logo_share-a2fa6d6cf1bf8935db021cfffa28f1b513be7067e3004cea9be3c5869151f2c9.png`,
          },
        },
        {
          '@type': 'WebSite',
          '@id': `${baseUrl}/#website`,
          url: `${baseUrl}/`,
          name: 'Tap.az',
          publisher: {
            '@id': `${baseUrl}/#organization`,
          },
          potentialAction: {
            '@type': 'SearchAction',
            target: `${baseUrl}/search?query={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
          inLanguage: i18n.language === 'ru' ? 'ru-AZ' : 'az-AZ',
        },
        {
          '@type': 'WebPage',
          '@id': `${baseUrl}/business#webpage`,
          url: `${baseUrl}/business`,
          name: title,
          description,
          isPartOf: {
            '@id': `${baseUrl}/#website`,
          },
          about: {
            '@id': `${baseUrl}/#organization`,
          },
          publisher: {
            '@id': `${baseUrl}/#organization`,
          },
          inLanguage: i18n.language === 'ru' ? 'ru-AZ' : 'az-AZ',
        },
      ],
    }),
    [baseUrl, title, description, i18n.language]
  );

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </Head>
  );
};
